export const LOADER_CRITERIOS_EVALUADOR         =       'LOADER_CRITERIOS_EVALUADOR';
export const GET_CRITERIOS_EVALUADOR            =       'GET_CRITERIOS_EVALUADOR';
export const CRITERIOS_EVALUADOR_FALLA          =       'CRITERIOS_EVALUADOR_FALLA';
export const SAVE_LOADER_CRITERIOS_EVALUADOR    =       'SAVE_LOADER_CRITERIOS_EVALUADOR';
export const FORM_CRITERIOS_EVALUADOR_FAIL      =       'FORM_CRITERIOS_EVALUADOR_FAIL';

